import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const UserRoutes: RouteObject = {
	path: "/user/*",
	children: [
		{
			index: true,
			// Should be new profile page
			lazy: async () => {
				const { Profile } =
					await import("@/app/application/admin-menu/Profile");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={(boundary) => (
								<PageError
									error={boundary.error}
									componentStack={boundary.componentStack}
									reset={() => boundary.resetError()}
								/>
							)}
						>
							<Profile />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "organizations/change",
			lazy: async () => {
				const { ChangeOrganization } =
					await import("@/components/Organizations/ChangeOrganization");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={(boundary) => (
								<PageError
									error={boundary.error}
									componentStack={boundary.componentStack}
									reset={() => boundary.resetError()}
								/>
							)}
						>
							<ChangeOrganization />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
